export const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    
    const formattedDate = date.toLocaleString("en-GB", {
        weekday: "long", // "Monday"
        year: "numeric", // "2025"
        month: "long", // "March"
        day: "numeric", // "17"
    });

    return formattedDate;
}

export const formatPhoneNumber = (phoneStr: string) => {
    const phoneNumber = phoneStr.trim(); // Remove any extra spaces

    if (phoneNumber.startsWith("0")) {
        return "234" + phoneNumber.slice(1); // Remove leading 0 and add 234
    } else if (phoneNumber.startsWith("234")) {
        return phoneNumber; // Already in the correct format
    }
    
    return "234" + phoneNumber; // If it doesn't start with 0 or 234, just add 234
}

export const thousandSeparator = (num: string) => {
    return num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const capitalizeWords = (str:string) => str.replace(/\b\w/g, (char) => char.toUpperCase());

export const stripHtmlTags = (html: string) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
}